import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from 'src/api/baseApi';
import rootReducer from './reducers';

/**
 * Factory for a fresh Redux store. Production code uses the singleton `store`
 * (exported below). Tests should call `makeStore()` per-test so RTK Query cache
 * and authSlice state stay isolated between cases.
 */
export const makeStore = () => {
  const instance = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
  });
  setupListeners(instance.dispatch);
  return instance;
};

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
